export const tour = {
  showProgress: false,
  steps: [
    {
      element: ".prefixes",
      popover: {
        title: "Prefix",
        description: "Click to select or deselect a prefix",
      },
    },
    {
      element: ".baseword",
      popover: {
        title: "Baseword",
        description: `You must use the base`,
      },
    },
    {
      element: ".suffixes",
      popover: {
        title: "Suffix",
        description: "Click to select or deselect a suffix",
      },
    },
    {
      element: "#result",
      popover: {
        title: "Result",
        description:
          "<span class='tourValidWord'>Valid word</span><br/><span class='tourInvalidWord'>Non-word</span>",
      },
    },
    {
      element: "#result_clear",
      popover: {
        title: "Clear",
        description: "Clears selected morphemes and result",
      },
    },
    {
      element: "#sum",
      popover: {
        title: "Sum",
        description: "This sum shows how your word is built",
      },
    },
    {
      element: "#clear_sum_button",
      popover: {
        title: "Clear",
        description: "Click here to clear sums and words built",
      },
    },
    {
      element: "#words_built",
      popover: {
        title: "Words built",
        description:
          "Click on words built to look up in the Merriam Webster dictionary",
      },
    },
    {
      element: "#words_built_counter",
      popover: {
        title: "Words built counter",
        description: "Shows how many words you can make",
      },
    },
    {
      element: "#baseword",
      popover: {
        title: "Base",
        description: "Select a base",
      },
    },
    {
      element: "#level",
      popover: {
        title: "Level",
        description: "Select level 1, 2 or 3",
      },
    },
    {
      element: "#clear_all",
      popover: {
        title: "Clear all",
        description: "Clear matrix selections, word sums and words built",
      },
    },
    {
      element: "#slides",
      popover: {
        title: "Lesson deck",
        description: "Show lesson slides within screen, or full screen",
      },
    },
    {
      element: "#rules",
      popover: {
        title: "Rules",
        description: "Review matrix and spelling rules",
      },
    },
    {
      element: "#printables",
      popover: {
        title: "Print resources",
        description: "Print reading passages and other activities",
      },
    },
    {
      element: "#settings1",
      popover: {
        title: "Settings",
        description: "Hide word sums to complete analytical word sums. ",
      },
    },
    {
      element: "#settings2",
      popover: {
        title: "Settings",
        description: "Hide words built to complete synthetic word sums",
      },
    },
    {
      element: "#help",
      popover: {
        title: "Help",
        description: "Restart this tour",
      },
    },
  ],
};
